/* import __COLOCATED_TEMPLATE__ from './card.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { bool, or } from '@ember/object/computed';
import { WithholdingType } from '@square/dashboard-protos/models/squareup/banking/withholding_config_model';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
let Card = (_dec = bool('config.completedAt'), _dec2 = computed('config.{enabled,withholdingConfigs}'), _dec3 = computed('config', 'isEnabled'), _dec4 = or('isDisabled', 'isCompleted'), _dec5 = computed('account.latestActiveWithholdingLocationNames'), _class = class Card extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "locationSelector", _descriptor3, this);
    _initializerDefineProperty(this, "config", _descriptor4, this);
    _defineProperty(this, "account", void 0);
    _defineProperty(this, "enableConfig", void 0);
    _defineProperty(this, "disableConfig", void 0);
    _defineProperty(this, "createConfig", void 0);
    _defineProperty(this, "editWithholding", void 0);
    _defineProperty(this, "editTarget", void 0);
    _defineProperty(this, "createConfigFromCompleted", void 0);
    _defineProperty(this, "salesTaxCount", void 0);
    _defineProperty(this, "salesTaxError", void 0);
    _defineProperty(this, "onSavingForClick", void 0);
    _defineProperty(this, "onTaxCollectedClick", void 0);
    _defineProperty(this, "onRetrySalesTax", void 0);
    _initializerDefineProperty(this, "isCompleted", _descriptor5, this);
    _initializerDefineProperty(this, "isInactive", _descriptor6, this);
  }
  get isSalesTaxConfig() {
    return Boolean(this.config && 'withholdingType' in this.config && this.config.withholdingType === WithholdingType.SALES_TAX);
  }
  _editWithholding() {
    if (!this.isInactive) {
      this.editWithholding();
    }
  }
  _editTarget() {
    if (!this.isInactive) {
      this.editTarget();
    }
  }
  get shouldToggleBeOn() {
    return this.config ? this.isEnabled : this.automationSubaccountState.shouldAutomationToggleBeOn;
  }
  get isEnabled() {
    if (!this.config) {
      return false;
    }
    if ('withholdingConfigs' in this.config) {
      return this.config.withholdingConfigs.some(config => config.isEnabled);
    }
    return this.config.enabled;
  }
  get isDisabled() {
    if (!this.config) {
      return false;
    }
    return !this.isEnabled;
  }
  get locationSubtext() {
    const locationNames = this.account?.latestActiveWithholdingLocationNames || [];
    if (locationNames.length === 1) {
      return locationNames[0];
    } else if (locationNames.length > 1) {
      return this.intl.t('banking.savings.automation.card.cardSales.multiUnitSubtext', {
        numLocations: locationNames.length
      });
    }
    return undefined;
  }
  async toggle() {
    if (!this.config) {
      await this.createConfig();
    } else if (this.isCompleted) {
      await this.createConfigFromCompleted();
    } else if (this.isEnabled) {
      await this.disableConfig();
    } else {
      await this.enableConfig();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "config", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_editWithholding", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_editWithholding"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_editTarget", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_editTarget"), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isCompleted", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isEnabled", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "isEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDisabled", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "isDisabled"), _class.prototype), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isInactive", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "locationSubtext", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "locationSubtext"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), _class);
export { Card as default };